"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var removeParams_exports = {};
__export(removeParams_exports, {
  removeParams: () => removeParams
});
module.exports = __toCommonJS(removeParams_exports);
function removeParams(state, paramNames) {
  if (!(state === null || state === void 0 ? void 0 : state.routes)) return state;
  return {
    ...state,
    routes: state.routes.map(function(route) {
      var newRoute = route;
      if (route.params) {
        var filtered = {
          ...route.params
        };
        var changed = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
        try {
          for (var _iterator = paramNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var name = _step.value;
            if (name in filtered) {
              delete filtered[name];
              changed = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
        if (changed) {
          newRoute = {
            ...newRoute,
            params: filtered
          };
        }
      }
      if (route.state) {
        var newState = removeParams(route.state, paramNames);
        if (newState !== route.state) {
          newRoute = {
            ...newRoute,
            state: newState
          };
        }
      }
      return newRoute;
    })
  };
}
//# sourceMappingURL=removeParams.js.map
